export default __webpack_public_path__ + "static/media/TG.c32bd41f.svg";